import { render, staticRenderFns } from "./XemGroup.vue?vue&type=template&id=3c1d6ff0&"
import script from "./XemGroup.vue?vue&type=script&lang=js&"
export * from "./XemGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports